<template>
  <WsCard001>
    <WsChips001 :value="value.chips" />
    <WsText001 is-ellipsis>
      {{ value.title }}
    </WsText001>
    <WsChips001 :value="value.tags" />
    <WsSpec001 :value="value.spec" />
    <WsButton001
      width-stretch
      flat-button
      :leading-icon="value.btnIcon"
      @click.native.prevent="$_btnClick()"
    >
      {{ value.btnText }}
    </WsButton001>
  </WsCard001>
</template>

<script>
export default {
  data() {
    return {
      value: {
        chips: [
          { leadingIcon: "icon-water", text: "dddd", color: "yellow" },
          { leadingIcon: "icon-water", text: "dddd", color: "red" },
        ],
        tags: [
          { leadingIcon: "icon-water", text: "rrr" },
          { leadingIcon: "icon-water", text: "rrr" },
        ],
        title: "可以放東西的卡片",
        spec: [
          { title: "title", text: "texttttt" },
          { title: "title", text: "texttttt" },
          { title: "title", text: "texttttt" },
        ],
        btnIcon: "icon-water",
        btnText: "按鈕按鈕按鈕",
      },
    }
  }
}
</script>